import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";

const useSearchBookmarks = (paramIdToAppend?: string | number) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const searchTextKey = paramIdToAppend
        ? `searchText_${paramIdToAppend}`
        : "searchText";
    const skipKey = paramIdToAppend ? `skip_${paramIdToAppend}` : "skip";

    const { [searchTextKey]: searchText = "" } =
        RouteUtils.queryStringToObject<{
            [searchTextKey]: string;
        }>(search);

    const onSearchTextChange = (newVal: string) => {
        const { [searchTextKey]: oldSearchText, ...otherParams } =
            RouteUtils.queryStringToObject<{
                [searchTextKey]: string;
                [key: string]: any;
            }>(search);
        replace(
            RouteUtils.appendQueryParams(pathname, {
                ...otherParams,
                [searchTextKey]: newVal,
                [skipKey]: 0,
            })
        );
    };

    return {
        searchText,
        onSearchTextChange,
        searchTextKey,
    };
};

export default useSearchBookmarks;
